'use strict';

angular.module('upResources').factory('StandardCreative', [
	'$resource',
	'$q',
	'URL',
	'API',
	'MailTemplateAttributes',
	'AppService',
	'ParseGeneric',
	function StandardCreative($resource, $q, URL, API, MailTemplateAttributes, AppService, ParseGeneric) {
		var Attributes = MailTemplateAttributes().attr;
		var Keys = MailTemplateAttributes().keys;

		var Resource = $resource(
			URL + API + 'standardCreative/:id',
			{},
			{
				get: {
					method: 'GET',
					isArray: false,
					transformResponse: ParseGeneric()
				},
				find: {
					method: 'GET',
					isArray: false,
					transformResponse: ParseGeneric()
				}
			}
		);

		var Model = {
			find: function (filter, options) {
				var params = angular.extend(filter || {}, options);
				return Resource.find(params).$promise;
			},

			get: function (id) {
				return Resource.get({ id: id }).$promise;
			},

			attr: Attributes,
			keys: Keys
		};

		return Model;
	}
]);
